import { FC } from 'react'

import { type UploadFileMediaContext } from './UploadFile.Media'
import { type Media } from 'content-types/UploadFile/UploadFile'

import { UploadFileImage } from 'content-types/UploadFile/UploadFile.Image/UploadFile.Image'
import { UploadFileSvg } from 'content-types/UploadFile/UploadFile.Svg/UploadFile.Svg'
import { UploadFileVideo } from 'content-types/UploadFile/UploadFile.Video/UploadFile.Video'

export const UploadFileMediaView: FC<UploadFileMediaContext & Media>
= ({
    embedSVG=true,
    ...media
}) =>
      media.mime === 'image/svg+xml' && embedSVG ? <UploadFileSvg {...media} />
    : media.mime === 'video/mp4' ? <UploadFileVideo {...media} />
    : <UploadFileImage {...media} />
